// src/components/complaints/ComplaintCard.js
import React from 'react';

function ComplaintCard({ complaint, onClick, isAdmin }) {
  const getStatusColor = (status) => {
    const colors = {
      pending: '#ffc107',
      acknowledged: '#17a2b8',
      in_progress: '#fd7e14',
      resolved: '#28a745',
      closed: '#6c757d'
    };
    return colors[status] || '#6c757d';
  };

  const getUrgencyColor = (urgency) => {
    const colors = {
      urgent: '#dc3545',
      high: '#ffc107',
      normal: '#28a745',
      low: '#17a2b8'
    };
    return colors[urgency] || '#6c757d';
  };

  const getCategoryIcon = (category) => {
    const icons = {
      maintenance: '🔧',
      cleanliness: '🧹',
      security: '🔒',
      noise: '🔇',
      parking: '🚗',
      amenities: '🏊',
      other: '📌'
    };
    return icons[category] || '📋';
  };

  return (
    <div
      onClick={onClick}
      style={{
        background: 'white',
        borderRadius: '10px',
        padding: '20px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
        borderLeft: `5px solid ${getStatusColor(complaint.status)}`,
        cursor: 'pointer',
        transition: 'transform 0.2s',
        ':hover': {
          transform: 'translateY(-2px)'
        }
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
            <span style={{ fontSize: '20px' }}>{getCategoryIcon(complaint.category)}</span>
            <h3 style={{ margin: 0, flex: 1 }}>{complaint.subject}</h3>
            <span style={{
              padding: '2px 8px',
              background: getUrgencyColor(complaint.urgency),
              color: 'white',
              borderRadius: '12px',
              fontSize: '11px',
              fontWeight: '600'
            }}>
              {complaint.urgency?.toUpperCase()}
            </span>
          </div>

          <p style={{ color: '#666', marginBottom: '10px', fontSize: '14px' }}>
            {complaint.description.substring(0, 150)}
            {complaint.description.length > 150 && '...'}
          </p>

          <div style={{ display: 'flex', gap: '20px', fontSize: '13px', color: '#999' }}>
            <span>📅 {new Date(complaint.created_at).toLocaleDateString()}</span>
            <span>🏠 {complaint.creator?.flat_number} - {complaint.creator?.name}</span>
            {complaint.location && <span>📍 {complaint.location}</span>}
            <span>#{complaint.complaint_number}</span>
          </div>
        </div>

        <div style={{ marginLeft: '20px' }}>
          <span style={{
            padding: '5px 12px',
            background: getStatusColor(complaint.status) + '20',
            color: getStatusColor(complaint.status),
            borderRadius: '15px',
            fontSize: '12px',
            fontWeight: '600'
          }}>
            {complaint.status?.replace('_', ' ').toUpperCase()}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ComplaintCard;